import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {filter, ignoreElements, of, withLatestFrom} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import { loadCredits, loadCreditsSuccess, loadCreditsFailure } from './subscription.actions';
import { SubscriptionService } from '../../services/subscription.service';
import {resetState} from "../global/global.actions";
import {selectIsLoggedIn} from "../auth/auth.selectors";
import {Store} from "@ngrx/store";

@Injectable()
export class SubscriptionEffects {

  // Load credits effect with isLoggedIn check
  loadCredits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCredits),
      // Check if user is logged in before making the API call
      withLatestFrom(this.store.select(selectIsLoggedIn)),
      // Only proceed if the user is logged in
      filter(([action, isLoggedIn]) => isLoggedIn),
      switchMap(() =>
        this.subscriptionService.getCredits().pipe(
          map(response => {
            return loadCreditsSuccess({
              current_balance: response.current_balance,
              last_allocation_date: response.last_allocation_date,
              next_allocation_date: response.next_allocation_date,
              subscription_amount: response.subscription_amount,
              credits: response.credits, // Backward compatibility
              ai_tokens: response.ai_tokens,
              user: response.user
            });
          }),
          catchError(error => {
            return of(loadCreditsFailure({ error }));
          })
        )
      )
    )
  );

  // Cancel requests when resetState action is dispatched
  cancelOnLogout$ = createEffect(() =>
      this.actions$.pipe(
        ofType(resetState),
        tap(() => {
          // Call service method to cancel ongoing requests
          this.subscriptionService.cancelRequests();
        })
      ),
    { dispatch: false } // This effect doesn't dispatch any actions
  );

  constructor(
    private actions$: Actions,
    private subscriptionService: SubscriptionService,
    private store: Store
  ) {}
}
